import React from 'react';
import AudienceLandingPage from './AudienceLandingPage';
import { FAMILY_OFFICE_CONFIG } from '../data/audienceLandingConfig';

const FamilyOfficeLandingPage: React.FC = () => (
  <AudienceLandingPage config={FAMILY_OFFICE_CONFIG} />
);

export default FamilyOfficeLandingPage;
